import { css } from '@emotion/core'
import { spacing, measures, colors, font } from 'styles/variables'

const { unit } = measures

export default {
  top: css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${spacing(6.5, 0)};
    overflow: hidden;
    font-family: ${font.family};
    height: 72vh;
  `,
  topTitle: css`
    margin-bottom: ${spacing(1.5)};
    color: ${colors.white100};
    font-size: ${font.size24};
    font-style: italic;
    font-weight: ${font.weight.extraBold};
    font-family: ${font.family};
  `,
  description: css`
    color: ${colors.white60};
    font-size: ${font.size18};
    font-weight: ${font.weight.medium};
    text-align: center;
    line-height: 24px;
  `,
  logInText: css`
    color: ${colors.white100};
  `,
  logInLink: css`
    text-decoration: none;
    color: ${colors.greens.green7};
    cursor: pointer;
  `,
  signUpBtn: css`
    margin-top: ${spacing(5)};
    margin-bottom: ${spacing(2.5)};
    background-color: ${colors.greens.green7};
    color: #000;
    width: ${unit * 30}px;
  `,
}
